function AlertBar() {
	const body = document.body;
	const alertContainer = document.getElementById('e29-alert-bar');
	const headerBar = document.querySelector('.main-header');
	const alertItems = alertContainer
		? alertContainer.querySelectorAll('.alert-bar__item')
		: false;
	const currentStorage = JSON.parse(sessionStorage.getItem('e29-alert-bar'));
	const alertState = currentStorage ? currentStorage : {};

	//Add height to body for other fixed/absolute elements

	// Create a function to handle the ResizeObserver for setting the header-bar-height.
	const handleResize = (isAlert = false) => {
		const headerContainerHeight = headerBar.offsetHeight;

		if (isAlert) {
			const alertContainerTop = alertContainer.offsetTop;
			const alertContainerHeight = alertContainer.offsetHeight;
			body.style.setProperty(
				'--alert-bar-height',
				`${alertContainerHeight + alertContainerTop}px`
			);
			body.style.setProperty(
				'--header-bar-height',
				`${alertContainerHeight + headerContainerHeight}px`
			);
		} else {
			body.style.setProperty(
				'--header-bar-height',
				`${headerContainerHeight}px`
			);
		}
	};

	handleResize(alertContainer ? true : false);

	if (alertContainer) {
		// Attach ResizeObserver to alertContainer
		const alertObserver = new ResizeObserver(() => handleResize(true));
		alertObserver.observe(alertContainer);
	} else {
		body.style.setProperty('--alert-bar-height', `0px`);
	}

	// Attach event listener for window resize
	window.addEventListener('resize', () => {
		if (alertContainer) {
			handleResize(true);
		} else {
			handleResize();
		}
	});

	//Manage viewed state
	function setStorage() {
		sessionStorage.setItem('e29-alert-bar', JSON.stringify(alertState));
	}

	if (alertItems) {
		alertItems.forEach((alertItem) => {
			const alertClose = alertItem.querySelector('.alert-bar__close');
			const alertID = alertItem.getAttribute('id');

			//Loop through local storage and determine what has been viewed
			if (currentStorage) {
				for (const item in currentStorage) {
					if (item === alertID && currentStorage[item].viewed) {
						document.getElementById(item).classList.add('viewed');
					}
					if (item === alertID && !currentStorage[item].viewed) {
						document
							.getElementById(item)
							.classList.remove('viewed');
					}
				}
			}

			//No local storage, set all to not viewed
			else {
				alertState[alertID] = { viewed: false };
				alertItem.classList.remove('viewed');
			}

			//Close alert item and set local storage
			if (alertClose) {
				alertClose.addEventListener('click', function (e) {
					e.preventDefault();
					alertItem.classList.add('viewed');
					alertState[alertID] = { viewed: true };
					setStorage();
				});
			}

			//Create local storage if it doesn't exist
			if (!currentStorage) {
				setStorage();
			}
		});
	}
}

export default AlertBar;
